import classnames from 'classnames';

import './editor.scss';

import EditableTabPanel from './EditableTabPanel';

const { TabPanel } = wp.components;
const { cloneElement, Children, useState, useEffect } = wp.element;
const { withSelect, withDispatch } = wp.data;
const { compose } = wp.compose;

const tabletIcon =
	<svg className="dashicon" height="14" viewBox="0 0 16 16" width="13" xmlns="http://www.w3.org/2000/svg"><path d="m11.25 0h-9c-.825 0-1.5.61363636-1.5 1.36363636v13.27272724c0 .75.675 1.3636364 1.5 1.3636364h9c.825 0 1.5-.6136364 1.5-1.3636364v-13.27272724c0-.75-.675-1.36363636-1.5-1.36363636zm-.5 14h-8v-12h8z" transform="translate(1.25)" /></svg>;

const mobileIcon =
	<svg className="dashicon" height="14" viewBox="0 0 16 16" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m6.5 0h-5c-.825 0-1.5.61363636-1.5 1.36363636v9.27272724c0 .75.675 1.3636364 1.5 1.3636364h5c.825 0 1.5-.6136364 1.5-1.3636364v-9.27272724c0-.75-.675-1.36363636-1.5-1.36363636zm-.5 10h-4v-8h4z" transform="translate(4 2)" /></svg>;

const desktopIcon =
	<svg className="dashicon" height="14" viewBox="0 0 16 16" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m12.5 0c.8325 0 1.5.61363636 1.5 1.36363636v11.27272724c0 .75-.675 1.3636364-1.5 1.3636364l-.5-2v-9h-10v9h10l.5 2h-11c-.8325 0-1.5-.6136364-1.5-1.3636364v-11.27272724c0-.75.6675-1.36363636 1.5-1.36363636zm-10 1c-.27614237 0-.5.22385763-.5.5s.22385763.5.5.5.5-.22385763.5-.5-.22385763-.5-.5-.5z" transform="translate(1 1.001872)" /></svg>;

const ResponsiveTabs = ( props ) => {
	const {
		breakpoints,
		selected,
		setPreviewDeviceType,
		onChangeAll,
	} = props;
	// const [ deviceType, setDeviceType ] = useState( 'Desktop' );

	useEffect( () => {
		onSelect( selected );
	}, [ selected ] );

	const [ isLinked, setIsLinked ] = useState( false );
	const [ tabs, setTabs ] = useState( [] );

	useEffect( () => {
		// on mount set the link button state correctly
		const allSame = allValuesOrCheckedSame( breakpoints );
		setIsLinked( allSame );
	}, []);

	useEffect( () => {
		const newTabs = [];
		breakpoints.map( ( breakpoint ) => {
			const { name, componentProps, title = null } = breakpoint;
			let tabTitle;

			if ( ! title ) {
				tabTitle = defaultTitles[ name ];
			} else {
				tabTitle = title;
			}

			const compositeOnChangeProps = {
				...componentProps,
				isLinked,
			};

			if ( isLinked ) {
				if ( typeof onChangeAll !== 'undefined' ) {
					compositeOnChangeProps.onChange = onChangeAll;
				} else {
					console.debug( 'at least one key not defined for responsive breakpoints', breakpoints );
				}
			}

			newTabs.push( {
				name,
				title: tabTitle,
				content: cloneElement( Children.only( props.children ), { ...compositeOnChangeProps } ),
			} );

		} );
		setTabs( newTabs );
	}, [ breakpoints ] );

	const tabClasses = {
		Desktop: classnames( 'eedee-responsive-icon', { 'eedee-active-tab': selected === 'Desktop' } ),
		Tablet: classnames( 'eedee-responsive-icon', { 'eedee-active-tab': selected === 'Tablet' } ),
		Mobile: classnames( 'eedee-responsive-icon', { 'eedee-active-tab': selected === 'Mobile' } ),
	};

	const defaultTitles = {
		Desktop: <span className={ tabClasses.Desktop }>{ desktopIcon }</span>,
		Tablet: <span className={ tabClasses.Tablet }>{ tabletIcon }</span>,
		Mobile: <span className={ tabClasses.Mobile }>{ mobileIcon }</span>,
	};

	const linkBtnClasses = classnames( 'eedee-responsive-link-button', {
		'is-active': isLinked,
	});

	const tabPanelClasses = classnames( 'eedee-responsive-tab-panel', {
		'is-linked': isLinked,
	} );

	function allValuesOrCheckedSame( bps ) {
		return ( typeof breakpoints[0].componentProps?.value !== 'undefined'
		&& breakpoints.slice(1).every( el => el.componentProps?.value === breakpoints[0].componentProps?.value ) )
		|| ( typeof breakpoints[0].componentProps?.checked !== 'undefined'
		&& breakpoints.slice(1).every( el => el.componentProps?.checked === breakpoints[0].componentProps?.checked ) );
	}

	function onSelect( tab ) {
		setPreviewDeviceType( tab );
	}

	function onChangeLink() {
		setIsLinked( ! isLinked );
	}

	return (
		<>
			<EditableTabPanel
				className={ tabPanelClasses }
				activeClass=""
				onSelect={ onSelect }
				tabs={ tabs }
				selectedTabName={ selected }
				isLinked={ isLinked }
				onChangeLink={ onChangeLink }
			>
				{
					( tab ) => {
						return (
							<div className="eedee-responsive-tab">
								{ tab.content }
							</div>
						);
					}
				}
			</EditableTabPanel>
		</>
	);
};

const composed = compose( [
	withDispatch( ( dispatch ) => {
		if ( ! dispatch( 'core/edit-post' ) ) {
			return {
				setPreviewDeviceType: () => {},
			}
		}
		const { __experimentalSetPreviewDeviceType } = dispatch( 'core/edit-post' );

		return {
			setPreviewDeviceType: __experimentalSetPreviewDeviceType,
		};
	} ),
] )( ResponsiveTabs );

export {
	composed as ResponsiveTabs,
};
